import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UsersAPI } from "../../../../api/users.api";
import { SessionStorageService } from "../../../../services/session-storage.service";

@Component({
  selector: "nb-login-token",
  styleUrls: ["../login/login.component.scss"],
  templateUrl: "login_key.component.html",
})
export class LoginKeyComponent {
  constructor(
    private route: ActivatedRoute,
    protected router: Router,
    protected usersAPI: UsersAPI,
    private session: SessionStorageService
  ) {}

  async ngOnInit() {
    let key = this.route.snapshot.params["key"];
    if (key) {
      this.usersAPI
        .loginKey(key)
        .then((login) => {
          if (login) {
            this.session.setToken(login.Token);
            this.session.setUserId(login.UserId);
            this.session.setUserName(login.Name);
            this.session.setUserGroup(login.Group);
            this.session.setUserGroupId(login.GroupId);
            this.session.setEmail(login.Email);
            this.session.setContactLink(login.ContactLink);

            this.router.navigateByUrl("pages");
          }
        })
        .catch((error) => {
          this.router.navigate(["auth"]);
        });
    } else {
      this.router.navigate(["auth"]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/components/login-key/login_key.component.ts